import {
  AirlineSeatFlat,
  EventBusy,
  InsertDriveFileOutlined,
  Mail,
  PanTool,
  TimerOffTwoTone,
  Warning,
} from "@mui/icons-material";
import { caseConstants } from "@_constants/case.constants";

/**
 * Single source of truth for the case filters.
 *
 * Each entry maps a `caseConstants.CASE_FILTER_*` value to:
 * - `icon`: the MUI icon component to render for that filter.
 * - `label`: the human-readable label shown in the filter UI.
 * - `apiKey`: the key sent to the API in the search object's `filter` payload
 *   (see `createSearchObject` in `Cases.js`). `null` when the filter has no
 *   corresponding API flag (e.g. the "none" filter).
 */
export const filterConfig = {
  [caseConstants.CASE_FILTER_MAIL]: {
    icon: Mail,
    label: "Unread Mails",
    apiKey: "unread_emails",
  },
  [caseConstants.CASE_FILTER_REMINDER]: {
    icon: EventBusy,
    label: "Overdue Reminder",
    apiKey: "overdue_reminders",
  },
  [caseConstants.CASE_FILTER_UPLOADED_LICENSE]: {
    icon: InsertDriveFileOutlined,
    label: "Uploaded Licenses",
    apiKey: "unchecked_licenses",
  },
  [caseConstants.CASE_FILTER_FAILED_EMAIL]: {
    icon: Warning,
    label: "Failed Emails",
    apiKey: "failed_emails",
  },
  [caseConstants.CASE_FILTER_FAILED_LETTERS]: {
    icon: Warning,
    label: "Failed Letters",
    apiKey: "failed_letters",
  },
  [caseConstants.CASE_FILTER_FAILED_PAYMENT]: {
    icon: Warning,
    label: "Failed Payments",
    apiKey: "failed_payments",
  },
  [caseConstants.CASE_FILTER_PAUSED]: {
    icon: TimerOffTwoTone,
    label: "Paused Scheduled Emails",
    apiKey: "paused_scheduled_emails",
  },
  [caseConstants.CASE_FILTER_REQUIRE_ATTENTION]: {
    icon: PanTool,
    label: "Action Required",
    apiKey: "action_required",
  },
  [caseConstants.CASE_FILTER_IDLE_CASES]: {
    icon: AirlineSeatFlat,
    label: "Idle Cases",
    apiKey: "idle",
  },
};

export default filterConfig;
